export const MAX_FILTERS = 9;
export const MAX_FILTERS_WITH_CALENDAR = MAX_FILTERS + 1;

export const MAX_LEVEL_LANGUAGE = 6;
export const MIN_LEVEL_LANGUAGE = 0;
